import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';

interface DateModalFooterProps {
  onSubmit: () => void;
  hideModal: () => void;
  title: string;
}

export const DateModalFooter = ({ onSubmit, hideModal, title }: DateModalFooterProps) => {
  return (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>{title}</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );
};
